// Mirror of server/src/config/institutions.js for display. The server is the
// source of truth for which domain belongs to which campus; the client only
// needs labels and order. Adding a key here without adding it there gives it
// a logo and a filter option no account can ever carry.
export const INSTITUTIONS = Object.freeze({
    msudenver: Object.freeze({
        key: 'msudenver',
        shortName: 'MSU Denver',
        name: 'Metropolitan State University of Denver',
    }),
    ucdenver: Object.freeze({
        key: 'ucdenver',
        shortName: 'CU Denver',
        name: 'University of Colorado Denver',
    }),
    ccd: Object.freeze({
        key: 'ccd',
        shortName: 'CCD',
        name: 'Community College of Denver',
    }),
    ahec: Object.freeze({
        key: 'ahec',
        shortName: 'AHEC',
        name: 'Auraria Higher Education Center',
    }),
});

export const INSTITUTION_KEYS = Object.freeze(Object.keys(INSTITUTIONS));

// Every institution owns buildings, so these are the same keys. Only AHEC's
// label carries the qualifier, because an AHEC-owned building is the one case
// where the servicing office is not the poster's own institution.
export const BUILDING_OWNER_LABELS = Object.freeze({
    msudenver: 'MSU Denver',
    ucdenver: 'CU Denver',
    ccd: 'CCD',
    ahec: 'AHEC (shared campus building)',
});

export function institutionLabel(key) {
    return INSTITUTIONS[key]?.shortName || key || '';
}
